import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';

const Header = ({ onShowInterest }) => {
  const [activeSection, setActiveSection] = useState('');
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['features', 'how-it-works', 'community', 'mission', 'faq'];
      const scrollPosition = window.scrollY + 150;

      let foundSection = '';
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop - 150;
          const offsetBottom = offsetTop + element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            foundSection = section;
            break;
          }
        }
      }

      if (foundSection !== activeSection) {
        setActiveSection(foundSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeSection]);

  const handleNavClick = (e, target) => {
    e.preventDefault();
    const element = document.getElementById(target);
    if (element) {
      const offsetTop = element.offsetTop - 120;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
      setActiveSection(target);
      setExpanded(false); // Close mobile menu
    }
  };

  const handleShowInterestClick = () => {
    onShowInterest();
    setExpanded(false); // Close mobile menu
  };

  return (
    <div className="header-wrapper">
      <div className="header-container">
        <Navbar expand="lg" className="header-navbar" expanded={expanded} onToggle={setExpanded}>
          <Container fluid className="px-4">
            {/* Logo */}
            <Navbar.Brand href="#home" className="d-flex align-items-center">
              <img 
                src="/images/logo.png" 
                alt="Nisa Care Logo" 
                className="header-logo"
              />
            </Navbar.Brand>
            
            {/* Toggle Button for Mobile */}
            <Navbar.Toggle aria-controls="navbar-nav" />
            
            {/* Navigation */}
            <Navbar.Collapse id="navbar-nav">
              <Nav className="mx-auto align-items-center gap-4">
                <Nav.Link 
                  href="#features" 
                  className={`nav-link-custom ${activeSection === 'features' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'features')}
                >
                  Features
                </Nav.Link>
                <Nav.Link 
                  href="#how-it-works" 
                  className={`nav-link-custom ${activeSection === 'how-it-works' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'how-it-works')}
                >
                  How it works
                </Nav.Link>
                <Nav.Link 
                  href="#community" 
                  className={`nav-link-custom ${activeSection === 'community' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'community')}
                >
                  Community
                </Nav.Link>
                <Nav.Link 
                  href="#mission" 
                  className={`nav-link-custom ${activeSection === 'mission' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'mission')}
                >
                  Mission
                </Nav.Link>
                <Nav.Link 
                  href="#faq" 
                  className={`nav-link-custom ${activeSection === 'faq' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'faq')}
                >
                  FAQ
                </Nav.Link>
              </Nav>
              
              <Button 
                className="show-interest-btn"
                onClick={handleShowInterestClick}
              >
                Show interest
              </Button>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;